import React from 'react';

/**
 * Converts URLs in text to clickable links
 * Supports http://, https://, and www. URLs
 */
export function linkify(text: string): React.ReactNode {
  if (!text) return text;

  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/gi;
  
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (!part) return null;
    
    // Check if this part is a URL
    if (part.match(urlRegex)) {
      // Add protocol if it's a www. URL
      const href = part.startsWith('www.') ? `https://${part}` : part;
      
      return (
        <a
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'var(--color-primary)',
            textDecoration: 'underline',
            wordBreak: 'break-all'
          }}
        >
          {part}
        </a>
      );
    }
    
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}

